import { httpRequest } from "../../http";
import {TraceSerializer} from "@models/serializers/traceSerializer.ts";
import {Trace} from "@models/trace.model.ts";

export class CommandGetTraceDetails {
    async run(traceId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/traces/${traceId}/`
        try {
            const response = await httpRequest<any>(url, { method: "GET" });
            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Trace {
        const serializer = new TraceSerializer();
        return serializer.deserialize(data);
    }

}
